import { Button } from '@/atoms/Button'
import type { AgencyUser } from '@/modules/agencies/types/agencyUser'
import { AgencyStatusPill } from '@/modules/agencies/components/AgencyStatusPill'
import { formatAgencyDate } from '@/modules/agencies/utils/formatAgencyDate'
import { getAgencyStatusTone } from '@/modules/agencies/utils/agencyStatusTone'

export type AgencyUsersTableProps = {
  users: AgencyUser[]
  onEditUser: (user: AgencyUser) => void
}

function formatUserName(user: AgencyUser): string {
  return `${user.firstName} ${user.lastName}`.trim()
}

function formatLastLogin(value: string | null): string {
  if (!value) {
    return 'Never'
  }
  return formatAgencyDate(value)
}

export function AgencyUsersTable({ users, onEditUser }: AgencyUsersTableProps) {
  return (
    <div className="overflow-x-auto border-2 border-ink bg-surface">
      <table className="min-w-full border-collapse text-left text-sm">
        <thead className="border-b-2 border-ink bg-paper">
          <tr>
            <th className="px-4 py-3 font-mono text-[0.68rem] uppercase tracking-[0.12em] text-muted">
              Name
            </th>
            <th className="px-4 py-3 font-mono text-[0.68rem] uppercase tracking-[0.12em] text-muted">
              Email
            </th>
            <th className="px-4 py-3 font-mono text-[0.68rem] uppercase tracking-[0.12em] text-muted">
              Role
            </th>
            <th className="px-4 py-3 font-mono text-[0.68rem] uppercase tracking-[0.12em] text-muted">
              Status
            </th>
            <th className="px-4 py-3 font-mono text-[0.68rem] uppercase tracking-[0.12em] text-muted">
              Last login
            </th>
            <th className="px-4 py-3 font-mono text-[0.68rem] uppercase tracking-[0.12em] text-muted">
              Created
            </th>
            <th className="px-4 py-3 font-mono text-[0.68rem] uppercase tracking-[0.12em] text-muted">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id} className="border-b border-line last:border-b-0">
              <td className="px-4 py-3 font-semibold text-ink">
                {formatUserName(user)}
              </td>
              <td className="px-4 py-3 font-mono text-[0.82rem] text-muted">
                {user.email}
              </td>
              <td className="px-4 py-3 text-muted">{user.role}</td>
              <td className="px-4 py-3">
                <AgencyStatusPill
                  status={user.status}
                  tone={getAgencyStatusTone(user.status)}
                />
              </td>
              <td className="px-4 py-3 text-muted">
                {formatLastLogin(user.lastLoginAt)}
              </td>
              <td className="px-4 py-3 text-muted">
                {formatAgencyDate(user.createdAt)}
              </td>
              <td className="px-4 py-3">
                <Button
                  type="button"
                  variant="ghost"
                  className="px-3 py-1.5 text-xs"
                  onClick={() => onEditUser(user)}
                >
                  Edit
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
